export const EDITOR_VERSION_KEY = 'sigma.editor.version';

export const getEditorVersion = () => {
  if (typeof window === 'undefined') return 'v2';
  try {
    const params = new URLSearchParams(window.location.search);
    const qp = params.get('editor');
    if (qp === 'legacy') return 'legacy';
    return 'v2';
  } catch (_) {
    return 'v2';
  }
};

export const setEditorVersion = (version) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(EDITOR_VERSION_KEY, version === 'v2' ? 'v2' : 'legacy');
  } catch (_) {
    // noop
  }
};
